/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default function PaymentLabels({ title, value }): JSX.Element {
    return (
        <div className="flex justify-between text-xl text-sm-gray-1">
            <span className="font-bold italic">{title}:</span>
            <span className="w-3/5 text-right">{value}</span>
        </div>
    );
}
